module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain"
  }, [_c('div', {
    staticClass: "posting-uploader"
  }, [_vm._l((_vm.postData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "posting-uploader-item"
    }, [_c('van-tag', {
      attrs: {
        "plain": "",
        "round": "",
        "closeable": ""
      },
      on: {
        "close": function($event) {
          return _vm.remove(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postData.length < _vm.limit),
      expression: " postData.length < limit"
    }],
    attrs: {
      "accept": _vm.accept,
      "after-read": _vm.uploadFile,
      "upload-icon": "column",
      "result-type": "text",
      "upload-text": _vm.uploadText
    }
  })], 2), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "color": "#1989fa"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a00c71f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/FileUploaderData.vue
// module id = 1564
// module chunks = 0